import { render, staticRenderFns } from "./transform.vue?vue&type=template&id=4ae63620&scoped=true&"
import script from "./transform.vue?vue&type=script&lang=js&"
export * from "./transform.vue?vue&type=script&lang=js&"
import style0 from "./transform.vue?vue&type=style&index=0&id=4ae63620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae63620",
  null
  
)

export default component.exports